<script lang="ts" setup>
	import usePurchaseApi from '~/services/apis/purchases-info'

	const { plan_id } = useRoute().params

	const { getPurchasePolicies } = usePurchaseApi()
	const searchVal = shallowRef('')
	const cellClass = 'text-xs text-gray-600 font-medium tracking-wide xl:whitespace-nowrap'
	const tableColumns: TableColumn[] = [
		{
			key: 'sn',
			dataIndex: 'sn',
			title: 'S/N',
			className: cellClass
		},
		{
			key: 'name',
			dataIndex: 'name',
			title: 'Dependant Name',
			className: cellClass
		},
		{
			key: 'attached',
			dataIndex: 'attached',
			title: 'Attached To',
			className: cellClass,
			customCell: () => ({
				class: 'text-center'
			})
		},
		{
			key: 'status',
			dataIndex: 'status',
			title: 'Status',
			className: cellClass
		},
		{
			key: 'details',
			dataIndex: 'details',
			title: 'Details',
			className: cellClass
		}
	]
	const tableOptions = computed<TableFilterOptions>(() => ({
		filter: {
			search: searchVal.value,
			is_dependant: true
		}
	}))
	const fetchPlanDependants = async () => {
		const result = await getPurchasePolicies(plan_id as string, {
			user_type: 'dependant'
		})
		return result?.data ?? null
	}
</script>

<template>
	<div class="w-full">
		<forms-search-field v-model:value="searchVal" class="w-full pl-5" />

		<div class="mt-5">
			<ui-data-table
				:columns="tableColumns"
				:records="fetchPlanDependants"
				table-columns-class="py-2 px-2 text-sm"
				:options="tableOptions"
			>
				<template #bodyCell="{ column, record }">
					<span v-if="column.key === 'name'">
						{{ record?.first_name ?? '-' }}
						{{ record?.last_name ?? '-' }}
					</span>
					<span v-if="column.key === 'attached'">
						{{ record?.meta?.staff_name || 'N/A' }}
					</span>
					<shared-badge
						v-if="column.key === 'status'"
						:text="record.is_expired ? 'expired' : 'active'"
						:active="!record.is_expired"
						:failed="record.is_expired"
						class="inline-flex"
					/>

					<nuxt-link
						v-if="column.key === 'details'"
						aria-roledescription="view beneficiary plan details"
						class="text-sm font-medium !text-primary-2"
						:to="`/mycover/custodian/${record?.meta?.staff_policy_id ?? record?.id ?? ''}?tab=dependant`"
					>
						View
					</nuxt-link>
				</template>
			</ui-data-table>
		</div>
	</div>
</template>
